import { render } from "./Repo.vue?vue&type=template&id=4194647c&ts=true"
import script from "./Repo.vue?vue&type=script&lang=ts"
export * from "./Repo.vue?vue&type=script&lang=ts"

import exportComponent from "/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__